const headers = import('next/headers');

/**
 * Gets the referer header for server-side requests
 */
export async function SERVERSIDE_getReferer(): Promise<string | null> {
  const headersFunction = await headers;

  return (await headersFunction.headers()).get('referer');
}
